import { Component, OnInit } from '@angular/core';
import { DataService } from '../../data.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import {MAT_MOMENT_DATE_FORMATS, MomentDateAdapter} from '@angular/material-moment-adapter';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import * as moment from 'moment';

import * as pdfMake from 'pdfmake/build/pdfmake.js';
import * as pdfFonts from 'pdfmake/build/vfs_fonts.js';
pdfMake.vfs = pdfFonts.pdfMake.vfs;


export const MY_FORMATS = {
  parse: {
    dateInput: 'L', 
  },
  display: {
    dateInput: 'L',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMM YYYY',
  },
};

@Component({
  selector: 'app-ingreso',
  templateUrl: './ingreso.component.html',
  styleUrls: ['./ingreso.component.css'],
  providers: [
    {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
    {provide: MAT_DATE_LOCALE, useValue: "es-MX" },
  ] 
})
export class IngresoComponent implements OnInit {
  errMsg:any;
  loading:boolean=false;
  data:any=[];
  dataDet:any=[];
  efectivo:any=[];
  otros:any=[];
  fecIni:any = moment();
  fecFin:any = moment();
  dias:any=[];
  totAsistencia:number = 0;
  totTotal:number = 0;
  totEfe:number = 0;
  totOtros:number = 0;
  separaDia:boolean=false;
  formato:any=[];
  formStyle:any[];
  elemImp:any[];
  elemStyle:any[]=[]  
  dd:any;
  jefe:any=[];
  idContabilidad:number; 
  contabilidad:any=[];
  esFechaEspecial:boolean=false;
  fechaEspecial:any=[];

  thisForm = new FormGroup({
    separaDia: new FormControl(this.separaDia, []),
  });


  constructor(private dataService: DataService) { }

  ngOnInit() {
    this.dataService.getFormatoImp(48, 1).subscribe(
                          rows => {   
                                  this.formato = <any>rows
                                  },          
                          error => this.errMsg = <any>error,
                          () => this.fnFormatoImpCargado());
    this.dataService.getVars("FEC-TIC").subscribe(
                      rows => {   
                              this.esFechaEspecial = <any>rows
                              },          
                      error => this.errMsg = <any>error,
                      () => this.fnFechaEspecialObtenida());   
    this.dataService.getJefe().subscribe(
                      rows => {   
                              this.jefe = <any>rows
                              },          
                      error => this.errMsg = <any>error,
                      () => this.fnJefeCargado());   
    this.dataService.getVars("REP-CON").subscribe(
                      rows => {   
                              this.idContabilidad = <any>rows
                              },          
                      error => this.errMsg = <any>error,
                      () => this.fnIdContabilidadCargado());                                         
  }

  fnJefeCargado(){
    //console.log(this.jefe);
  }

  fnIdContabilidadCargado(){
    //console.log(this.idDestinatario);
    this.dataService.getDestinatario(this.idContabilidad).subscribe(
                      rows => {   
                              this.contabilidad = <any>rows
                              },          
                      error => this.errMsg = <any>error,
                      () => this.fnContabilidadCargado());

  }

  fnContabilidadCargado(){
    //console.log(this.contabilidad);
  }

  fnFechaEspecialObtenida(){
    //console.log(this.esFechaEspecial);
    if(this.esFechaEspecial){
      this.dataService.getFechaEspecial().subscribe(
                      rows => {   
                              this.fechaEspecial = <any>rows
                              },          
                      error => this.errMsg = <any>error,
                      () => this.fnFechaEspecial());
    }
        else{
      this.dias.push({'fecha': moment(this.fecIni).format("DD/MM/YYYY"),
                      'asistencia': this.totAsistencia , 
                      'total': this.totTotal,
                      'totalEfe': this.totEfe,
                      'totalOtros': this.totOtros
                    });
      this.fnCargaReporte(this.separaDia ? 'SI' : 'NO', this.fecIni.format("YYYYMMDD"), this.fecFin.format("YYYYMMDD"));
    }
  }

  fnFechaEspecial(){
    //console.log(this.fechaEspecial);
    this.fechaEspecial = moment(this.fechaEspecial[0].fecha.substr(6,4) + "/" + this.fechaEspecial[0].fecha.substr(3,2) + "/" + this.fechaEspecial[0].fecha.substr(0,2)).format("YYYY/MM/DD");
    this.fecIni = moment(this.fechaEspecial);
    this.fecFin = moment(this.fechaEspecial);
    this.dias.push({'fecha': moment(this.fecIni).format("DD/MM/YYYY"),
                      'asistencia': this.totAsistencia , 
                      'total': this.totTotal,
                      'totalEfe': this.totEfe,
                      'totalOtros': this.totOtros
                    });
    setTimeout(() => {
      this.fnCargaReporte(this.separaDia ? 'SI' : 'NO', this.fecIni.format("YYYYMMDD"), this.fecFin.format("YYYYMMDD"));
    }, 50);
  }

  fnGruposCargados(){
    //console.log(this.gpo);
  }

  fnCargaReporte(agrupar: string, fecIni:string, fecFin:string){
    this.loading=true;
    this.dataService.repIngreso(agrupar, fecIni, fecFin).subscribe(
                      rows => {   
                              this.data = <any>rows
                              },          
                      error => this.errMsg = <any>error,
                      () => this.fnReporteCargado());
  }

  fnCargaReporteDetalle(agrupar: string, fecIni:string, fecFin:string){
    this.loading=true;
    this.dataService.repIngresoDet(agrupar, fecIni, fecFin).subscribe(
                      rows => {   
                              this.dataDet = <any>rows
                              },          
                      error => this.errMsg = <any>error,
                      () => this.fnReporteDetCargado());
  }

  fnReporteCargado(){
    console.log(this.data);
    this.totAsistencia = 0;
    this.totTotal = 0;
    for(var d = 0; d < this.dias.length; d++){
      this.dias[d].area = "";
      this.dias[d].asistencia = 0;
      this.dias[d].total = 0;
      this.dias[d].totalEfe = 0;
      this.dias[d].totalOtros = 0;
    }
    for(var i = 0; i < this.data.length; i++){
      this.totAsistencia += this.data[i].asistencia;
      this.totTotal += this.data[i].total;
      for(var d = 0; d < this.dias.length; d++){
        if(this.dias[d].fecha == this.data[i].fecha){
          this.dias[d].area = this.data[i].area;
          this.dias[d].asistencia += this.data[i].asistencia;
          this.dias[d].total += this.data[i].total;
        }
      }
    }
    this.fnCargaReporteDetalle(this.separaDia ? 'SI' : 'NO', this.fecIni.format("YYYYMMDD"), this.fecFin.format("YYYYMMDD"));
  }

  fnReporteDetCargado(){
    console.log(this.dataDet);
    this.efectivo = [];
    this.otros = [];
    for(var i = 0; i < this.dataDet.length; i++){
      if(this.dataDet[i].idForma == 11)
        this.efectivo.push(this.dataDet[i]);
      else
        this.otros.push(this.dataDet[i]);
        for(var d = 0; d < this.dias.length; d++){
          if(this.dias[d].fecha == this.dataDet[i].fecha){
            if(this.dataDet[i].idForma == 11)
              this.dias[d].totalEfe += this.dataDet[i].total;
            else
              this.dias[d].totalOtros += this.dataDet[i].total;
          }
        }
    }
    console.log(this.dias)
    this.loading=false;
  }

  fnImprimeReporte(idFormato){
    //console.log("Imprime Reporte");
    this.dataService.insLog(48,'IMPRIMIR', "INGRESOS",'').subscribe(
                            row => { var l = <any>row; }, error => this.errMsg = <any>error, () => "" );          
    this.dataService.getElemFormatoImp(idFormato, "'CONTENT', 'COLUMN', 'CELL', 'NEW_LINE', 'NEW_ROW', 'STYLE', 'POSITION', 'LINE', 'RECT', 'ELLIPSE', 'END DRAW', 'IMAGE', 'GRAF1', 'GRAF2', 'GRAF3', 'GRAF4'", "1,2").subscribe(
                            rows => {   
                                    this.elemImp = <any>rows
                                    },          
                            error => this.errMsg = <any>error,
                            () => this.fnElementosImpresionCargados(idFormato, 0));              
  }

  fnElementosImpresionCargados(idFormato, ii){
    var index = this.formato.findIndex(x => x.id === idFormato);
    var margins =this.formato[index].pageMargins.split(",");
    var height = 1.0;
    height = this.formato[index].lineHeight;
    var text = [];
    var text2 = [];
    var canvas = [];
    var images = [];  

    var arrSpecialStrings = [{
      'FECHAEMI': this.dias[ii].fecha,
      'FILTRO1': "",
      'MONTO': "$ " + this.dataService.fnFormatMoney(this.dias[0].total, 2),
      'LINEA1': this.data.length > 0 ? this.data[0].area + "   <" + this.data[0].asistencia + ">" : "",
      'MONTO1': this.data.length > 0 ? "$ " + this.dataService.fnFormatMoney(this.data[0].total, 2) : "",
      'LINEA2': this.data.length > 1 ? this.data[1].area + "   <" + this.data[1].asistencia + ">"  : "",
      'MONTO2': this.data.length > 1 ? "$ " + this.dataService.fnFormatMoney(this.data[1].total, 2) : "",
      'LINEA3': this.data.length > 2 ? this.data[2].area + "   <" + this.data[2].asistencia + ">"  : "",
      'MONTO3': this.data.length > 2 ? "$ " + this.dataService.fnFormatMoney(this.data[2].total, 2) : "",
      'LINEA4': this.data.length > 3 ? this.data[3].area + "   <" + this.data[3].asistencia + ">"  : "",
      'MONTO4': this.data.length > 3 ? "$ " + this.dataService.fnFormatMoney(this.data[3].total, 2) : "",
      'LINEA5': this.data.length > 4 ? this.data[4].area + "   <" + this.data[4].asistencia + ">"  : "",
      'MONTO5': this.data.length > 4 ? "$ " + this.dataService.fnFormatMoney(this.data[4].total, 2) : "",
      'LINEA6': this.data.length > 5 ? this.data[5].area + "   <" + this.data[5].asistencia + ">"  : "",
      'MONTO6': this.data.length > 5 ? "$ " + this.dataService.fnFormatMoney(this.data[5].total, 2) : "",
      'LINEA7': this.data.length > 6 ? this.data[6].area + "   <" + this.data[6].asistencia + ">"  : "",
      'MONTO7': this.data.length > 6 ? "$ " + this.dataService.fnFormatMoney(this.data[6].total, 2) : "",
      'LINEA8': this.data.length > 7 ? this.data[7].area + "   <" + this.data[7].asistencia + ">"  : "",
      'MONTO8': this.data.length > 7 ? "$ " + this.dataService.fnFormatMoney(this.data[7].total, 2) : "",

      'SUBEFECTIVO': "$ " + this  .dataService.fnFormatMoney(this.dias[0].totalEfe, 2),
      'LINEA11': this.efectivo.length > 0 ? this.efectivo[0].area : "",
      'MONTO11': this.efectivo.length > 0 ? "$ " + this.dataService.fnFormatMoney(this.efectivo[0].total, 2) : "",
      'LINEA12': this.efectivo.length > 1 ? this.efectivo[1].area : "",
      'MONTO12': this.efectivo.length > 1 ? "$ " + this.dataService.fnFormatMoney(this.efectivo[1].total, 2) : "",
      'LINEA13': this.efectivo.length > 2 ? this.efectivo[2].area : "",
      'MONTO13': this.efectivo.length > 2 ? "$ " + this.dataService.fnFormatMoney(this.efectivo[2].total, 2) : "",
      'LINEA14': this.efectivo.length > 3 ? this.efectivo[3].area : "",
      'MONTO14': this.efectivo.length > 3 ? "$ " + this.dataService.fnFormatMoney(this.efectivo[3].total, 2) : "",
      'LINEA15': this.efectivo.length > 4 ? this.efectivo[4].area : "",
      'MONTO15': this.efectivo.length > 4 ? "$ " + this.dataService.fnFormatMoney(this.efectivo[4].total, 2) : "",
      'LINEA16': this.efectivo.length > 5 ? this.efectivo[5].area : "",
      'MONTO16': this.efectivo.length > 5 ? "$ " + this.dataService.fnFormatMoney(this.efectivo[5].total, 2) : "",
      'LINEA17': this.efectivo.length > 6 ? this.efectivo[6].area : "",
      'MONTO17': this.efectivo.length > 6 ? "$ " + this.dataService.fnFormatMoney(this.efectivo[6].total, 2) : "",
      'LINEA18': this.efectivo.length > 7 ? this.efectivo[7].area : "",
      'MONTO18': this.efectivo.length > 7 ? "$ " + this.dataService.fnFormatMoney(this.efectivo[7].total, 2) : "",
      'LINEA19': this.efectivo.length > 8 ? this.efectivo[8].area : "",
      'MONTO19': this.efectivo.length > 8 ? "$ " + this.dataService.fnFormatMoney(this.efectivo[8].total, 2) : "",
      
      'SUBOTROS': "$ " + this  .dataService.fnFormatMoney(this.dias[0].totalOtros, 2),
      'LINEA21': this.otros.length > 0 ? this.otros[0].area + " " + this.otros[0].forma : "",
      'MONTO21': this.otros.length > 0 ? "$ " + this.dataService.fnFormatMoney(this.otros[0].total, 2) : "",
      'LINEA22': this.otros.length > 1 ? this.otros[1].area + " " + this.otros[1].forma : "",
      'MONTO22': this.otros.length > 1 ? "$ " + this.dataService.fnFormatMoney(this.otros[1].total, 2) : "",
      'LINEA23': this.otros.length > 2 ? this.otros[2].area + " " + this.otros[2].forma : "",
      'MONTO23': this.otros.length > 2 ? "$ " + this.dataService.fnFormatMoney(this.otros[2].total, 2) : "",
      'LINEA24': this.otros.length > 3 ? this.otros[3].area + " " + this.otros[3].forma : "",
      'MONTO24': this.otros.length > 3 ? "$ " + this.dataService.fnFormatMoney(this.otros[3].total, 2) : "",
      'LINEA25': this.otros.length > 4 ? this.otros[4].area + " " + this.otros[4].forma : "",
      'MONTO25': this.otros.length > 4 ? "$ " + this.dataService.fnFormatMoney(this.otros[4].total, 2) : "",
      'LINEA26': this.otros.length > 5 ? this.otros[5].area + " " + this.otros[5].forma : "",
      'MONTO26': this.otros.length > 5 ? "$ " + this.dataService.fnFormatMoney(this.otros[5].total, 2) : "",
      'LINEA27': this.otros.length > 6 ? this.otros[6].area + " " + this.otros[6].forma : "",
      'MONTO27': this.otros.length > 6 ? "$ " + this.dataService.fnFormatMoney(this.otros[6].total, 2) : "",
      'LINEA28': this.otros.length > 7 ? this.otros[7].area + " " + this.otros[7].forma : "",
      'MONTO28': this.otros.length > 7 ? "$ " + this.dataService.fnFormatMoney(this.otros[7].total, 2) : "",
      'LINEA29': this.otros.length > 8 ? this.otros[8].area + " " + this.otros[8].forma : "",
      'MONTO29': this.otros.length > 8 ? "$ " + this.dataService.fnFormatMoney(this.otros[8].total, 2) : "",

      'JEFE_TAQ': this.jefe.length > 0 ? (this.jefe[0].nombre.length > 30 ? this.jefe[0].nombre.substr(0, 30) : this.jefe[0].nombre) : null,
      'CONTABILIDAD': this.contabilidad.length > 0 ? (this.contabilidad[0].nombre.length + this.contabilidad[0].apPat.length > 30 ? (this.contabilidad[0].nombre + " " + this.contabilidad[0].apPat).substr(0, 30) : this.contabilidad[0].nombre + " " + this.contabilidad[0].apPat ) : null,
      //'DESCUENTO': (this.idDesc > 0 ? '(' + this.dataService.findItemInObject(this.descs, this.idDesc, "id").descuento + ')' : '')
    }];
    var auxTxtMargen = [0,0,0,0];
    for(var i = 0; i < this.elemImp.length; i++){
      if(this.elemImp[i].tipo == "content"){
        if(this.elemImp[i].margin.indexOf(",") > 0)
          auxTxtMargen = this.elemImp[i].margin.split(",");
          auxTxtMargen = auxTxtMargen.map(function (x) {  
            return parseInt(x.toString(), 10); 
          }); 
        //console.log(auxTxtMargen);   --> NO FUNCIONAN MARGENES EN TEXTO
        text.push({
                    text: this.dataService.fnReplaceSpecialStrings(this.elemImp[i].dato, arrSpecialStrings),
                    style: this.elemImp[i].style,
                    margin: [0,0,0,0],
                    color: this.elemImp[i].color,
                    alignment: this.elemImp[i].alignment
                  });                  
      }
      if(this.elemImp[i].tipo == "position"){
        text2.push({
                    text: this.dataService.fnReplaceSpecialStrings(this.elemImp[i].dato, arrSpecialStrings),
                    style: this.elemImp[i].style,
                    color: this.elemImp[i].color,
                    alignment: this.elemImp[i].alignment,                              
                    absolutePosition: {x: parseInt(this.elemImp[i].margin.split(",")[0]), y: parseInt(this.elemImp[i].margin.split(",")[1])}
                  });                  
      }
      if(this.elemImp[i].tipo == 'image' && this.elemImp[i].dato == "ƒLOGO" ){
        images.push({
                    //image:  this.dataService.fnGetBase64Image(auxLogo, auxLogo.naturalWidth, auxLogo.naturalHeight),
                    image: 'logoBlack.png',
                    fit: [85, 30],
                    alignment: this.elemImp[i].alignment,
                    absolutePosition: {x: parseInt(this.elemImp[i].margin.split(",")[0]), y: parseInt(this.elemImp[i].margin.split(",")[1]) }
                   })
      }
      if(this.elemImp[i].tipo == 'line'){
          canvas.push({
                      type: 'line',
                      r: 0,
                      x1: parseInt(this.elemImp[i].margin.split(",")[0]),
                      y1: parseInt(this.elemImp[i].margin.split(",")[1]),
                      x2: parseInt(this.elemImp[i].margin.split(",")[2]),
                      y2: parseInt(this.elemImp[i].margin.split(",")[3]),
                      lineColor: this.elemImp[i].color,
                      lineWidth: this.elemImp[i].alignment                               
                    })
      }
      if(this.elemImp[i].tipo == 'rect'){
        canvas.push({
                    type: 'rect',
                    r: 5,
                    fillOpacity: 0.3,
                    color: this.elemImp[i].style,
                    x: parseInt(this.elemImp[i].margin.split(",")[0]),
                    y: parseInt(this.elemImp[i].margin.split(",")[1]),
                    w: parseInt(this.elemImp[i].margin.split(",")[2]),
                    h: parseInt(this.elemImp[i].margin.split(",")[3]),
                    lineColor: this.elemImp[i].color,
                    lineWidth: this.elemImp[i].alignment                               
                  })
      }
    }

    var styles = this.elemStyle;
    var stack = [];
    if (this.formato[index].tipo == "TABLA")
      stack[0] = text;
    else
      stack.push({text:text});
    stack[1] = text2;
    stack.push({canvas:canvas});
    this.dd = {
      //pageSize: this.formato[index].pageSize,
      pageSize: 'letter',
      pageOrientation: this.formato[index].pageOrientation,
      pageMargins: [parseInt(margins[0]), parseInt(margins[1]), parseInt(margins[2]), parseInt(margins[3])],
      content: [
        {
          lineHeight: 1.0,
          alignment: 'left',
          background: 'white',
          color: 'black',
          stack       
        }
        ,images   
      ],
      styles
    }
    //pdfMake.createPdf(this.dd).print();
    pdfMake.createPdf(this.dd).open();
  }
    


  fnFormatoImpCargado(){
    //console.log("Formatos: ");
    //console.log(this.formato);
    var arrIdForms = [];
    for(var i = 0; i < this.formato.length; i++){
      arrIdForms.push(this.formato[i].id);
    }
    //--> Obtener styles
    this.dataService.getFormStyles(arrIdForms.join(","), "1,2").subscribe(
                rows => {   
                        this.formStyle = <any>rows
                        },          
                error => this.errMsg = <any>error,
                () => this.fnFormStyleCargado())
  }

  fnFormStyleCargado(){
    //console.log(this.formStyle)
    var arrStyles=[];
    for(var i = 0; i < this.formStyle.length; i++){
      arrStyles.push(this.formStyle[i].style);
    }
    arrStyles = arrStyles.filter(this.dataService.onlyUnique);        
    for(var i = 0; i < arrStyles.length; i++){
      this.elemStyle[arrStyles[i]] = {};
      for(var k = 0; k < this.formStyle.length; k++){
        if(arrStyles[i] == this.formStyle[k].style){
            var auxObj = Object.keys(this.elemStyle[arrStyles[i]]);
            //console.log("Keys of Object:");
            //console.log(auxObj);
            if(auxObj.length == 0)
              this.elemStyle[arrStyles[i]] = {[this.formStyle[k].key]:this.formStyle[k].valor} ;
            else
              this.elemStyle[arrStyles[i]][this.formStyle[k].key]   = this.formStyle[k].valor;
        }
      }
    }
    //console.log(this.elemStyle);
  }

  onChange(idEl, item, tipo){
    //console.log("onChange: " + tipo)
    this.onClick(idEl,item,tipo);
  }

  onClick(idEl, item, tipo){
    //console.log(tipo);
    //console.log("onClick: " + idEl);
    //console.log(item); 
  }

  fnClickDia(elem:any){
    setTimeout(() => {
      //console.log(this.thisForm.controls["separaDia"].value);
      if(this.thisForm.controls["separaDia"].value){
        this.separaDia = true;
      } 
      else{
        this.separaDia = false;
      }   
      this.fnCambiaFecha("", null);  
    }, 10);
  }
  
  fnCambiaFecha(tipo, obj){
    if (tipo=="INI"){
      this.fecIni = moment(obj.value.format("YYYYMMDD"));
    }
    if (tipo=="FIN"){
      this.fecFin = moment(obj.value.format("YYYYMMDD"));
    }
    this.dias = [];
    if(this.separaDia){
      for(var d = 0; d <= this.fecFin.diff(this.fecIni, "days"); d++){
        var newDate = moment(this.fecIni).add(d, "days");
        this.dias.push({'fecha': newDate.format("DD/MM/YYYY"),
                        'asistencia': 0,
                        'total': 0
                      })
      }
    }
    else{
      if(moment(this.fecIni).format("DD/MM/YYYY") != moment(this.fecFin).format("DD/MM/YYYY"))
        this.dias.push({'fecha': 'Del ' + moment(this.fecIni).format("DD/MM/YYYY") + ' al ' + moment(this.fecFin).format("DD/MM/YYYY"),
                        'asistencia': this.totAsistencia,
                        'total': this.totTotal
                      })
      else
        this.dias.push({'fecha': moment(this.fecIni).format("DD/MM/YYYY"),
                        'asistencia': this.totAsistencia , 
                        'total': this.totTotal
                      });
    }
    //console.log(this.dias);
    this.fnCargaReporte(this.separaDia ? 'SI' : 'NO', moment(this.fecIni).format("YYYYMMDD"), moment(this.fecFin).format("YYYYMMDD"));
  }

}
